import { render, staticRenderFns } from "./Page06.vue?vue&type=template&id=73574e8e&scoped=true&"
import script from "./Page06.vue?vue&type=script&lang=js&"
export * from "./Page06.vue?vue&type=script&lang=js&"
import style0 from "./Page06.vue?vue&type=style&index=0&id=73574e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73574e8e",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QInput,QIcon,QPopupProxy,QDate,QSelect,QField} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QInput,QIcon,QPopupProxy,QDate,QSelect,QField}, component.options.components || {})
